import React from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import { NAV_TYPE_SIDE, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import { Scrollbars } from "react-custom-scrollbars";
import MenuContent from "./MenuContent";
import { useTheme } from "../../data/hooks/theme/useTheme";

const { Sider } = Layout;

export const SideNav = ({ routeInfo, hideGroupTitle, localization = true }) => {
  const { navCollapsed, sideNavTheme } = useTheme();
  const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };

  return (
    <Sider
      className={`side-nav`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed}
      style={{
        overflow: "auto",
        position: "sticky",
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: "thin",
        scrollbarGutter: "stable",
        background: "white",
      }}
    >
      <Scrollbars autoHide>
        <MenuContent type={NAV_TYPE_SIDE} {...props} />
      </Scrollbars>
    </Sider>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme } = theme;
  return { navCollapsed, sideNavTheme };
};

export default connect(mapStateToProps)(SideNav);
